import React from "react"

import {
  FacebookShareButton,
  // HatenaShareButton,
  LineShareButton,
  // PocketShareButton,
  TwitterShareButton,
} from "react-share";
// import {
//   HatenaShareCount,
// } from "react-share";

const Share = ({ message, title ,url ,twitterid }) => (
  <div>
    <ul className="text-center">
      <li className="block md:inline xl:block pb-3 md:pr-3 lg:pb-3 text-sm text-center text-gray-500 align-middle">{message}</li>
      <li className="block md:inline xl:block align-middle"><FacebookShareButton url={url}>
        <svg className="w-12 h-12 fill-gray">
          <use xlinkHref="#icon-facebook" />
        </svg>
      </FacebookShareButton></li>
      <li className="block md:inline xl:block align-middle"><TwitterShareButton title={title} via={twitterid} url={url}>
        <svg className="w-12 h-12 fill-gray">
          <use xlinkHref="#icon-twitter" />
        </svg>
      </TwitterShareButton></li>
      <li className="block md:inline xl:block align-middle"><LineShareButton url={url}>
        <svg className="w-12 h-12 fill-gray">
          <use xlinkHref="#icon-line" />
        </svg>
      </LineShareButton></li>
    </ul>
  </div>
)

export default Share
